export default {
  checkedBlockPriceCategories: [],
  blockPriceCategoryList: [],
  selectedBlockPriceCategoryModel: null
}
